import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import './Sidebar.css'

const Sidebar = () => {

  const sidebarList = [
   
    {
      name: 'User',
      to:'/admin/users'
    },
    {
      name: 'Add Product',
      to:'/admin/products'
    },
    {
      name: 'Orders',
      to: '/admin/orders'
    }
  ]

  const [activeList, setActiveList] = useState('All')
  return (
    <>
        <div className='sidebar'>
            <ul>
                {
                 sidebarList.map((item) => <li className={item.name === activeList ? 'active': '' } onClick={()=>setActiveList(item.name) }><Link to={item.to}>{item.name}</Link></li>)
                }
            </ul>
        </div>

    </>
  )
}

export default Sidebar